// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"296":"4f240cb0","300":"8cf3fae0","592":"a9dd5dc1","599":"8cf3fae0"}[chunkId] + ".chunk.css";
};